import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import "../style/pages/_politiqueConfidentialite.scss";

const PolitiqueConfidentialite = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: "/politique-de-confidentialite",
            title: "Politique de Confidentialité",
        });
    });

    return (
        <div>
            <main>
                <div className='legals-container'>

                    <h1>Politique de Confidentialité d'O3 Académie</h1>

                    <article>
                        <h2>1. Introduction</h2>
                        <p>Cette politique de confidentialité vous informe de la manière dont O3 Académie collecte,
                            utilise, et protège vos informations personnelles lorsque vous utilisez notre site internet <strong><a href="https://www.o3academie.fr">https://www.o3academie.fr</a></strong> et nos services.</p>
                    </article>

                    <article>
                        <h2>2. Identité du responsable de traitement</h2>
                        <p><strong>Propriétaire et responsable de la publication :</strong></p>
                        <ul className="legals-ul">
                            <li>O3 Académie <br />
                                50 Avenue de Pont Cher<br />
                                BP 30509<br />
                                37205 Tours Cedex 3</li>
                            <li>contact@o3academie.fr</li>
                        </ul>
                        <p><strong>Responsable de la publication :</strong> O3 Académie – contact@o3academie.fr</p>
                        <p><strong>Responsable de la conception du site :</strong> Christophe Bon – contact@o3academie.fr</p>
                        <p><strong>Hébergeur :</strong> Gandi SAS – 63-65 boulevard Masséna, 75013 Paris, France</p>
                        <p><strong>Délégué à la protection des données (DPO) :</strong> Cabinet CC COMPLIANCE, 1 Impasse du
                            Palais, 37000 Tours</p>
                    </article>

                    <article>
                        <h2>3. Données collectées</h2>
                        <p>Nous collectons les informations suivantes lorsque vous utilisez notre site ou nos services:</p>
                        <ul className="legals-ul">
                            <li>Via les cookies: informations de connexion et de navigation</li>
                            <li>Via le formulaire de contact: nom et prénom, adresse e - mail, adresse postale et
                                numéro de téléphone</li>
                        </ul>
                    </article>

                    <article>
                        <h2> 4. Finalité du traitement des données</h2 >
                        <p>Les informations recueillies sont utilisées pour:</p>
                        <ul className="legals-ul">
                            <li>Vous fournir les services demandés</li>
                            <li>Améliorer notre site et nos services</li>
                            <li>Répondre à vos demandes de contact et d’information</li>
                        </ul>
                    </article>

                    <article>
                        <h2> 5. Conservation des données</h2 >
                        <p>Les données personnelles sont conservées pendant une durée de 36 mois à compter de la
                            dernière interaction avec nos services.Passé ce délai, elles seront supprimées ou
                            anonymisées.</p>
                    </article>

                    <article>
                        <h2> 6. Partage des Données</h2 >
                        <p>Vos données personnelles ne sont pas partagées avec des tiers, excepté :</p>
                        <ul className="legals-ul">
                            <li>Si nous avons votre autorisation</li>
                            <li>Si la loi ou une autorité gouvernementale l’exige</li>
                        </ul>
                    </article>

                    <article>
                        <h2> 7. Sécurité des Données</h2 >
                        <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles
                            appropriées pour protéger vos données personnelles contre toute destruction, perte,
                            altération, divulgation ou accès non autorisé.</p>
                    </article>

                    <article>
                        <h2> 8. Vos Droits</h2 >
                        <p>Conformément à la loi « informatique et libertés », vous disposez des droits suivants
                            concernant vos données personnelles:</p>
                        <ul className="legals-ul">
                            <li>Droit d’accès</li>
                            <li>Droit de rectification</li>
                            <li>Droit à l’effacement</li>
                            <li>Droit à la limitation du traitement</li>
                            <li>Droit à la portabilité des données</li>
                            <li>Droit d’opposition</li>
                        </ul>
                        <p>Vous pouvez exercer ces droits en nous contactant à l’adresse suivante:</p>
                        <ul className="legals-ul">
                            <li>O3 Académie <br />
                                50 Avenue de Pont Cher<br />
                                BP 30509<br />
                                37205 Tours Cedex 3</li>
                            <li>contact @o3academie.fr</li>
                        </ul>
                    </article>

                    <article>
                        <h2>9. Cookies</h2>
                        <p>Notre site utilise des cookies pour améliorer votre expérience utilisateur. Vous pouvez
                            configurer votre navigateur pour refuser les cookies. Cependant, certaines fonctionnalités du
                            site pourraient ne pas fonctionner correctement sans cookies.</p>
                    </article>

                    <article>
                        <h2> 10. Modification de la Politique de Confidentialité</h2 >
                        <p>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment.<br />
                            Toute modification sera publiée sur cette page. Nous vous encourageons à consulter
                            régulièrement cette politique pour être informé de toute mise à jour.</p>
                    </article>

                    <article className="last-article">
                        <h2> 11. Contact</h2 >
                        <p>Pour toute question concernant cette politique de confidentialité, vous pouvez nous
                            contacter à l’adresse suivante:</p>
                        <ul className="legals-ul">
                            <li>O3 Académie<br />
                                50 Avenue de Pont Cher<br />
                                BP 30509<br />
                                37205 Tours Cedex 3</li>
                            <li>contact @o3academie.fr</li>
                        </ul>
                    </article>
                </div>
            </main >
        </div >
    );
};

export default PolitiqueConfidentialite;